// Plaka karşılaştırması — boşluklar yok sayılır (backend ile aynı mantık).
// "07 BES 033" ↔ "07BES033"

export const normalizePlate = (plate) =>
  String(plate || "")
    .toUpperCase()
    .replace(/\u00A0/g, " ")
    .replace(/\s+/g, "")
    .trim();

export const platesMatch = (plateA, plateB) => normalizePlate(plateA) === normalizePlate(plateB);

export const findVehicleByPlate = (vehicles, plate) => {
  if (!plate || !vehicles?.length) return null;
  return vehicles.find((v) => platesMatch(v.plate, plate)) || null;
};
